import simple from '../SimpleLayout';

const Layouts = {
  simple,
};

export default Layouts;
